module.exports = __webpack_public_path__ + "static/media/application-doc.25c262c4.svg";